import { BygrProject } from '@/types';
import { request } from '@/utils/ajax';

export interface ChangeRequestStatistics {
    total: number;
    averageSpending: number;
    unassigned: number;
    awaitingOffers: number;
    readyToSend: number;
    sentToBuyer: number;
    acceptedByBuyer: number;
    rejected: number;
    closed: number;
    canceledBySeller: number;
}
export function getChangeRequestStatistics(projectIds: number[]): Promise<ChangeRequestStatistics> {
    return request(`api/statistics/change-request`, {
        query: { projectIds },
    }).then((x) => x.json());
}

export interface CommentThreadStatistics {
    total: number;
    buyerThreads: number;
    sellerThreads: number;
    residentialUnit: number;
    changeRequest: number;
    order: number;
    externalAgreement: number;
    case: number;
}

export function getCommentThreadStatistics(projectIds: number[]): Promise<CommentThreadStatistics> {
    return request(`api/statistics/comment-threads`, {
        query: { projectIds },
    }).then((x) => x.json());
}

export interface CommentMessageStatistics {
    total: number;
    lastSentMessage: Date | string;
    numberOfAttachments: number;
    sentBySeller: number;
    sentByBuyer: number;
}
export function getCommentMessageStatistics(projectIds: number[]): Promise<CommentMessageStatistics> {
    return request(`api/statistics/comment-message`, {
        query: { projectIds },
    }).then((x) => x.json());
}

export interface SpendingCurrency {
    id: number;
    code: string;
}

export interface SpendingStatistics {
    changeRequests: number;
    buyerOptions: number;
    averageChangeRequestSpendingPerUnit: number;
    averageBuyerOptionSpendingPerUnit: number;
    total: number;
    totalAverage: number;
    currencies: SpendingCurrency[];
    selectedCurrencyId: number | null;
}
export function getSpending(projectIds: number[], currencyId?: number): Promise<SpendingStatistics> {
    return request(`api/statistics/spending`, {
        query: { projectIds, currencyId },
    }).then((x) => x.json());
}
export interface BygrDashboardData {
    users: number;
    units: number;
    projects: number;
    changeRequests: number;
    products: number;
    cmProjects: number;
    amProjects: number;
    qmProjects: number;
    salesProjects: number;
    cases: number;
}

export function getBygrData(): Promise<BygrDashboardData> {
    return request(`api/statistics/bygr-data`).then((x) => x.json());
}

export interface BygrVisitData {
    today: number;
    last7Days: number;
    last30Days: number;
}
export function getBygrVisitData(): Promise<BygrVisitData> {
    return request(`api/statistics/bygr-visit-data`).then((x) => x.json());
}

export function getNewProjects(): Promise<BygrProject[]> {
    return request(`api/statistics/new-projects`).then((x) => x.json());
}
export interface LiveItem {
    id: number;
    name: string;
    detail: string | null;
    at: string;
}

export interface LiveStatistics {
    activeNow: number;
    activeLast24Hours: number;
    /** 24 hourly buckets of distinct active users, oldest first. */
    activeUsersPerHour: number[];
    totalUsers: number;
    newUsersToday: number;
    newUsersLast7Days: number;
    totalProjects: number;
    newProjectsLast30Days: number;
    latestUsers: LiveItem[];
    recentlyActive: LiveItem[];
    latestProjects: LiveItem[];
    latestProfiles: LiveItem[];
}

export function getLiveStatistics(): Promise<LiveStatistics> {
    return request('api/statistics/live').then((x) => x.json());
}
